import React from "react";

const Card = ({ img, title, text, bold, textEnd = "?", pop }) => {
  return (
    <div className="card">
      <img className="card-img-top" src={img} alt={title} />
      <div className="card-body">
        <h5 className="card-title">{title}</h5>
        <p>
          {text}
          <b> {bold}</b>
          {textEnd}
        </p>
        <p className="pop">{pop}</p>
      </div>
    </div>
  );
};

export default Card;
